import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { AdFreeChatBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function AdFreeChat() {
  return (
    <>
      <SEO
        title="Ad-Free Random Video Chat - No Popups | Talkvee"
        description="Tired of annoying ads? Talkvee offers a 100% ad-free random video chat experience. Meet new people instantly without interruptions or hidden fees."
        pathname="/ad-free-video-chat"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Ad-Free Video Chat", "item": "https://talkvee.com/ad-free-video-chat" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <AdFreeChatBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">100% Ad-Free Random Video Chat</h1>
          <p className="landing-subtitle">
            Most chat sites are cluttered with intrusive ads and popups. Talkvee is different. We provide a clean, fast, and completely ad-free environment so you can focus on meeting real people.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Ad-Free Chat</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Why Choose Talkvee?</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>🚫 Zero Ads</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                No mid-roll videos, no banners, and no popups. Your conversation is never interrupted.
              </p>
            </div>
            <div style={{background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h4 style={{margin: '0 0 10px', color: '#1e293b', fontSize: '1.1rem'}}>⚡ Faster Loading</h4>
              <p style={{margin: 0, color: '#475569', lineHeight: '1.6'}}>
                Without heavy ad scripts, Talkvee loads instantly on any connection, including mobile data.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee really ad-free?",
              a: "Yes! We do not show any third-party advertisements, popups, or banners on our platform."
            },
            {
              q: "How does Talkvee stay free without ads?",
              a: "We prioritize user experience and community growth. We want to build the best platform for meeting people, not the one with the most ads."
            },
            {
              q: "Do I have to pay for an ad-free experience?",
              a: "No. Unlike other sites that charge for 'Premium' ad-free access, Talkvee is ad-free for everyone by default."
            }
          ]}
        />
      </div>
    </>
  );
}